'use es6';

import { memo, useEffect } from 'react';
import classNames from 'classnames';
import { Table } from 'foundations-components/transitional/components/Table';
import CrossTabRow from './CrossTabRowRenderer';
import CrossTabHeader from './CrossTabHeaderRenderer';
import CrossTabTotalsRow from './CrossTabTotalsRowRenderer';
import { Alignments } from '../crossTabRecords';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "CrossTabRenderer__StyledDiv",
  componentId: "sc-1epr8zn-0"
})(["padding-inline:", ";width:100%;height:100%;transform:translate3d(0,0,0);"], ({
  theme
}) => theme.space['400']);
export const getAlignClasses = align => classNames(align === Alignments.left && 'text-left', align === Alignments.right && 'text-right');
const renderRows = (visualization, flattenedRowData, dataColumns, rowEncodingsWithLabels, originalVisualization) => flattenedRowData && flattenedRowData.map((rowData, index) => /*#__PURE__*/_jsx(CrossTabRow, {
  index: index,
  visualization: visualization,
  rowData: rowData,
  dataColumns: dataColumns,
  rowEncodingsWithLabels: rowEncodingsWithLabels,
  originalVisualization: originalVisualization
}, index));
const CrossTabVisualization = ({
  visualization,
  rowEncodingsWithLabels,
  headerEncodingsWithLabels,
  columnEncodingsWithLabels,
  flattenedRowData,
  originalVisualization,
  onReportVisualize
}) => {
  useEffect(() => {
    onReportVisualize === null || onReportVisualize === void 0 || onReportVisualize();
  }, [onReportVisualize]);
  const {
    columnTotal,
    showColumnTotal
  } = visualization;
  const showColumnTotals = columnTotal.count() > 0 || showColumnTotal;
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(StyledDiv, {
      "data-test-id": "cross-tab-report",
      children: /*#__PURE__*/_jsxs(Table, {
        condensed: true,
        flush: true,
        children: [/*#__PURE__*/_jsx(CrossTabHeader, {
          headerEncodingsWithLabels: headerEncodingsWithLabels,
          rowEncodingsWithLabels: rowEncodingsWithLabels,
          visualization: visualization
        }), showColumnTotals && /*#__PURE__*/_jsx(CrossTabTotalsRow, {
          visualization: visualization,
          dataColumns: columnEncodingsWithLabels,
          labelSpan: rowEncodingsWithLabels.length,
          originalVisualization: originalVisualization
        }), /*#__PURE__*/_jsx("tbody", {
          children: renderRows(visualization, flattenedRowData, columnEncodingsWithLabels, rowEncodingsWithLabels, originalVisualization)
        })]
      })
    })
  );
};
export default /*#__PURE__*/memo(CrossTabVisualization);